export const MAX_YEAR_DIFF = 21;
